<div class="form-header">
  <span *ngIf="edited.id">Edit</span>
  <span *ngIf="!edited.id">Add</span>
  treatment
</div>
<form [formGroup]="treatmentForm" (ngSubmit)="onSubmitForm(treatmentForm)" >
  
<div class="dialog-container" >
  <div class="field" required>
    <mat-form-field>
      <mat-label>Treatment name</mat-label>
      <input matInput formControlName="name"  name="name">
    </mat-form-field>
  </div>
  <div class="field" required >
    <mat-form-field >
      <mat-label>Description/Dosage</mat-label>
      <textarea class="description-field" rows="4" columns="50" matInput formControlName="description" name="description"></textarea>
    </mat-form-field>
  </div>
  <div class="button-container">
    <button class="dialog-button" [disabled]="isFormInValid()" type="submit" mat-flat-button color="primary" >Save</button>
    <button class="dialog-button" mat-flat-button color="primary" type="reset" (click)="close()">Cancel</button>
  </div>
</div>


</form>